import { UI_STYLES } from "@/styles/uiStyles";

interface SubscriptionAproveNavigateToPaymentModalContentProps {
  onClose: () => void;
  url: string;
}

export const SubscriptionAproveNavigateToPaymentModalContent = ({
  url,
  onClose,
}: SubscriptionAproveNavigateToPaymentModalContentProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full ">
      <div className=" text-white text-sm leading-relaxed p-4 text-center mb-6 hide-scrollbar max-h-[300px] overflow-y-auto">
        <p className="mb-4 text-center text-lg">
          Для продолжения подписки, пожалуйста, перейдите на страницу оплаты.
        </p>
     
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} hover:bg-cyan-700 text-white px-4 text-center rounded-xl py-3 mb-2 transition`}
      >
        Перейти на страницу оплаты
      </a>
      </div>
    </div>
  );
};
